import { render, staticRenderFns } from "./pages-layout.vue?vue&type=template&id=28ca1167&scoped=true&"
import script from "./pages-layout.ts?vue&type=script&lang=ts&"
export * from "./pages-layout.ts?vue&type=script&lang=ts&"
import style0 from "./pages-layout.scss?vue&type=style&index=0&id=28ca1167&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ca1167",
  null
  
)

export default component.exports